import React from 'react';
import AdminNav from './AdminNav';

const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-naqd-light-background dark:bg-naqd-dark-background">
      <div className="flex h-screen">
        {/* Sidebar */}
        <div className="w-64 flex-shrink-0">
          <AdminNav />
        </div>
        
        {/* Main Content */}
        <div className="flex-1 overflow-auto">
          <div className="p-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;